export default {
    selectedCableInputTool: state => state.selectedCableInputTool,
    cablesNeededCount: state => state.cablesNeededCount,
    cableSelectionMessage: state => state.cableSelectionMessage,
    cablesSelectedCount: state => state.cablesSelectedCount,
    totalCablesSubmittedData: state => state.totalCablesSubmittedData,
    selectedAdditionalAccessoryOption: state => state.selectedAdditionalAccessoryOption,
    cableSelectionMessageType: state => state.cableSelectionMessageType,
}
